import styled, { css } from 'styled-components';
import { FontSize, FontWeight, spacing } from 'commons';

export const Main = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const filterBorderAndBackground = css`
  background-color: ${({ theme }) => theme.neutral_100};
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: ${spacing.input.borderRadius};
`;

export const DropdownButton = styled.button<{ $isOpen?: boolean }>`
  width: 100%;
  height: ${spacing.input.height};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 16px;
  color: ${({ theme }) => theme.neutral_900};
  cursor: pointer;

  ${filterBorderAndBackground}

  .wrapper {
    color: ${({ theme }) => theme.neutral_900};
    display: flex;
    align-items: center;
    gap: 8px;
  }

  svg {
    color: ${({ theme }) => theme.primary_300};
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      border-bottom-color: transparent;
      border-radius: ${spacing.input.borderRadius} ${spacing.input.borderRadius}
        0 0;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    `}
`;

export const ArrowWrapper = styled.div<{ $isOpen?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

export const Overlay = styled.button`
  display: block;
  opacity: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 7;
`;

const FORM_MARGIN = 16;

export const Form = styled.form<{
  $parentPosition?: number;
}>`
  position: absolute;
  top: calc(100% - 1px);
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 80vh;
  max-height: 80vh;
  padding: 16px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  scrollbar-gutter: stable;
  z-index: 8;

  ${filterBorderAndBackground}

  border-top: none;
  border-radius: 0 0 ${spacing.input.borderRadius} ${spacing.input.borderRadius};

  ${({ $parentPosition }) =>
    $parentPosition &&
    `height: calc(calc(100dvh - ${$parentPosition + FORM_MARGIN}px) - 100%);`}
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
  p {
    font-size: ${FontSize.font12};
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const SalesMode = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SalesModeCheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
`;

export const SelectWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;

  button {
    font-weight: ${FontWeight.bold};
    font-size: ${FontSize.font12};

    &[type='submit'] {
      width: 124px;
      min-width: unset;
    }
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid transparent;

  &:hover {
    border-color: ${({ theme }) => theme.neutral_300};
  }
`;
